import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <img 
            src="https://customer-assets.emergentagent.com/job_d2da4572-5a6d-445a-b5f9-58d5fd59f3d9/artifacts/f8wmpwl3_Logo%20Open%20Cortex.svg" 
            alt="Open Cortex" 
            className="logo"
          />
        </Link>
        
        <nav className="main-nav">
          <Link 
            to="/" 
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
          >
            Accueil
          </Link>
          <Link 
            to="/offre" 
            className={`nav-link ${isActive('/offre') ? 'active' : ''}`}
          >
            Offre
          </Link>
          <Link 
            to="/methode" 
            className={`nav-link ${isActive('/methode') ? 'active' : ''}`}
          >
            Méthode
          </Link>
          <Link 
            to="/pourquoi" 
            className={`nav-link ${isActive('/pourquoi') ? 'active' : ''}`}
          >
            Pourquoi Open Cortex
          </Link>
          <Link 
            to="/faq" 
            className={`nav-link ${isActive('/faq') ? 'active' : ''}`}
          >
            FAQ
          </Link>
          <Link 
            to="/contact" 
            className={`nav-link nav-link-contact ${isActive('/contact') ? 'active' : ''}`}
          >
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
}